import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { WISHLIST } from '../../brands/default/features';
import { LINK_WISHLIST } from '../../brands/default/links';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import HeaderIcon from './HeaderIcon';

const onClickIcon = (router) => {
  redirectToURL(LINK_WISHLIST, router);
};

const HeaderWishlist = ({ quantity = null }) => {
  const theme = useContext(ThemeContext);
  const router = useRouter();
  const userState = useSelector((state) => state.user.isAuthenticated);
  const ariaHasPopup = userState || null;
  const ariaExpanded = userState || null;

  return (
    <>
      {WISHLIST && (
        <HeaderIcon
          ariaExpanded={ariaExpanded}
          ariaHasPopup={ariaHasPopup}
          badgeContent={quantity}
          clickMethod={() => onClickIcon(router)}
          icon="wishlist"
        />
      )}
      <style jsx>{`
        .menulogin-container {
          position: relative;
        }
        ul.list {
          padding: 0;
          margin: 0;
          list-style: none;
          width: 100%;
        }
      `}</style>
      <style global jsx>{`
        li.account__menu-item {
          padding: 4px 5px 4px 10px;
          display: block;
          cursor: pointer;
          text-align: -webkit-match-parent;
        }
        li.account__menu-item:hover {
          background: ${theme.colors.primary};
          color: white;
        }
      `}</style>
    </>
  );
};

HeaderWishlist.propTypes = {
  quantity: PropTypes.string,
};

HeaderWishlist.defaultProps = {
  quantity: null,
};

export default HeaderWishlist;
